var exports = {
  "Pf": "xe7b6e3d6--297478--label",
  "wm": "xe7b6e3d6--297478--logo",
  "_8": "xe7b6e3d6--297478--img",
};

module.exports = exports;
